import options2Map from '@/utils/options2Map'

export const LOGISTIC_MATCH_RULE_ENUMS = {
  CUSTOM: 'custom',
  SYSTEM: 'system',
}

/** 匹配规则 */
export const LOGISTIC_MATCH_RULE_OPTIONS = [
  {
    value: LOGISTIC_MATCH_RULE_ENUMS.SYSTEM,
    label: 'common.system.default',
  },
  {
    value: LOGISTIC_MATCH_RULE_ENUMS.CUSTOM,
    label: 'common.custom',
  },
]

/** 匹配方式 */
export const LOGISTIC_MATCH_TYPE_OPTIONS = [
  {
    value: 1,
    label: 'logistic.match.allWord',
  },
  {
    value: 2,
    label: 'logistic.match.likeWord',
  },
]

/** 匹配方式Map */
export const LOGISTIC_MATCH_TYPE_OPTIONS_MAPS = options2Map(LOGISTIC_MATCH_TYPE_OPTIONS)
